import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CfPopoverBase } from 'components/popover-host/popover-interface';
import { PopoverController } from 'providers/popover-controller';

export interface SetDetailInfo {
  setText: string;
  dataText: string;
  userNotes?: string;
}

export interface CsLogDetailPopoverParams {
  dateTitle: string;  // e.g. "Last Workout - Wednesday, August 12"
  subtitle?: string;  // e.g. "Same intensity level" for DUP/TUP
  sets: SetDetailInfo[];
}

@Component({
  selector: 'cs-log-detail-popover',
  templateUrl: 'cs-log-detail-popover.html',
  host: { 'class': 'log-detail-popover' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsLogDetailPopover extends CfPopoverBase {
  @Input() params: CsLogDetailPopoverParams;

  static async present(
    popoverCtrl: PopoverController,
    targetElement: HTMLElement,
    params: CsLogDetailPopoverParams
  ): Promise<void> {
    await popoverCtrl.present(
      CsLogDetailPopover,
      { params },
      {
        targetFromElement: targetElement,
        animate: true,
        showBackdrop: true,
        bottomSheet: true
      }
    );
  }

  constructor(
    private popoverCtrl: PopoverController
  ) {
    super();
  }

  onWillDismiss(_data: any) {
    // no data needed
  }

  onCloseClick() {
    void this.popoverCtrl.dismiss(this, {});
  }
}
